import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concat, EMPTY, from, Observable, of } from 'rxjs';
import { catchError, switchMap, map, tap } from 'rxjs/operators';
import { HttpService } from '../../global/http.service';

import * as taxDetails from './tax-details.actions';
import { TaxDetailsRequestPayload } from './tax-details.models';
import { isNullOrUndefined } from 'util';
import { DatesInterval, DatesIntervalRequest } from '../../global/interfaces';
import { downloadFile } from '../../global/fileDownload';
import { Actions as ActionsCDK } from "atlas-cdk";
import { ToastService } from '../../shared/toaster_/toaster_.service';


@Injectable()
export class TaxDetailsEffects {

    public loadTaxDetailsDates$ = createEffect(() => this.actions$.pipe(
        ofType<taxDetails.LoadTaxDetailsDatesAction>(taxDetails.ActionTypes.LOAD_TAX_DETAILS_DATES),
        map(action => action.payload),
        switchMap((payload: DatesIntervalRequest) =>
            this.loadTaxDetailsDates(payload).pipe(
                map((response: DatesInterval) =>
                    new taxDetails.LoadTaxDetailsDatesSuccessAction(response)
                ),
                catchError(error =>
                    // from([
                    //     new taxDetails.LoadTaxDetailsDatesFailedAction(error),
                    //     new AddErrorToastAction(!isNullOrUndefined(error.error)
                    //         && !isNullOrUndefined(error.error.message) ? error.error.message : error.message)
                    // ])
                    // {
                    //     this._toasterService.launchAlertError(error.error != null && error.error.message != null ? error.error.message : error.message, ActionsCDK.error);
                    //     return of(new taxDetails.LoadTaxDetailsDatesFailedAction(error));
                    // }
                    concat(
                        of(new taxDetails.LoadTaxDetailsDatesFailedAction(error)),
                        of(null).pipe(
                            tap(() => {
                                const errorMessage = (error?.error != null && error.error.message != null)
                                    ? error.error.message
                                    : error.message;
                                this._toasterService.launchAlertError(errorMessage, ActionsCDK.error);
                            })
                        )
                    )
                )
            )
        )
    ));

    public loadTaxDetails$ = createEffect(() => this.actions$.pipe(
        ofType<taxDetails.LoadTaxDetailsAction>(taxDetails.ActionTypes.LOAD_TAX_DETAILS),
        map(action => action.payload),
        switchMap((payload: TaxDetailsRequestPayload) =>
            this.loadTaxDetails(payload).pipe(
                map((response: any) =>
                    new taxDetails.LoadTaxDetailsSuccessAction(response)
                ),
                catchError(error =>
                    // from([
                    //     new taxDetails.LoadTaxDetailsFailedAction(error),
                    //     new AddErrorToastAction(!isNullOrUndefined(error.error)
                    //         && !isNullOrUndefined(error.error.message) ? error.error.message : error.message)
                    // ])
                    // {
                    //     this._toasterService.launchAlertError(error.error != null && error.error.message != null ? error.error.message : error.message, ActionsCDK.error);
                    //     return of(new taxDetails.LoadTaxDetailsFailedAction(error));
                    // }
                    concat(
                        of(new taxDetails.LoadTaxDetailsFailedAction(error)),
                        of(null).pipe(
                            tap(() => {
                                const errorMessage = (error?.error != null && error.error.message != null)
                                    ? error.error.message
                                    : error.message;
                                this._toasterService.launchAlertError(errorMessage, ActionsCDK.error);
                            })
                        )
                    )
                )
            )
        )
    ));

    public fileDownload$ = createEffect(() => this.actions$.pipe(
        ofType<taxDetails.TaxDetailsFileDownloadAction>(taxDetails.ActionTypes.TAX_DETAILS_FILE_DOWNLOAD),
        map(action => action.payload),
        switchMap((payload: TaxDetailsRequestPayload) =>
            this.downloadTaxDetailsFile(payload).pipe(
                map((response: any) => {
                    // deepcode ignore DOMXSS:internally created secure response
                    downloadFile(response.body, '*/*', 'TaxDetailsExport.csv');
                }),
                catchError(() => {
                    // (from([
                    //     new AddErrorToastAction('Download failed. Please try again later.')
                    // ]))
                    this._toasterService.launchAlertError('Download failed. Please try again later.', ActionsCDK.error);
                    return EMPTY;
                }
                )
            )
        )
    ), { dispatch: false });


    public constructor(
        private readonly actions$: Actions,
        private readonly http: HttpService,
        private readonly _toasterService: ToastService
    ) {
    }

    private loadTaxDetailsDates(payload: DatesIntervalRequest): Observable<DatesInterval> {
        return this.http.get(`/metrics/${payload.account}/date-ranges/tax-details`);
    }

    private loadTaxDetails(payload: TaxDetailsRequestPayload): Observable<[]> {
        return this.http.post(`/tax-details/accounts/${payload.account}`,
            { date: payload.date, country: payload.country, startDate: payload.startDate });
    }

    private downloadTaxDetailsFile(payload: any): Observable<any> {
        return this.http.post(`/tax-details/accounts/${payload.id}/exports`, {
            date: payload.date,
            country: payload.country,
            startDate: payload.startDate,
            userDate: payload.userDate
        }, {
            observe: 'response',
            responseType: 'blob'
        });
    }
}
